function mountNotification(status, messageHeader, messageText) {
  let notifier = document.getElementById('NotificationComponentForReact');
  if (notifier) removeNotifier(notifier);

  notifier = document.createElement('aside');
  notifier.id = 'NotificationComponentForReact';

  const icon = document.createElement('figure');
  switch (status) {
    case 1: /// Update status success
      icon.classList.add('note-to-user');
      break;
    case 2:
      icon.classList.add('bad-configuration');
      break;
    case 500:
      icon.classList.add('server-error');
      break;
    case 400:
      icon.classList.add('incorrect-sign-in');
      break;
    case 401:
      icon.classList.add('session-timed-out');
      break;
    case 'note':
      icon.classList.add('note-to-user');
      break;
    case 'autosave':
      icon.classList.add('notification__autosave-icon');
      break;
    default:
      icon.classList.add('server-error');
  }
  notifier.appendChild(icon);

  const messageElement = document.createElement('div');

  if (status !== 'autosave') {
    const closeButton = document.createElement('div');
    messageElement.appendChild(closeButton);
    closeButton.classList.add('notification-close-button');
  }

  const messageHeaderHolder = document.createElement('h4');
  messageHeaderHolder.innerText = messageHeader;
  messageElement.appendChild(messageHeaderHolder);

  if (messageText) {
    const messageTextHolder = document.createElement('p');
    messageTextHolder.innerText = messageText;
    messageElement.appendChild(messageTextHolder);
  }

  notifier.appendChild(messageElement);
  document.body.appendChild(notifier);

  notifier.addEventListener('click', ()=>{closeNotification(notifier)});
  notifier.addEventListener('animationend', () => {
    removeNotifier(notifier);
  });

  return notifier;
}

function closeNotification(notifier) {
  if (!notifier.classList.contains('close')) notifier.classList.add('close');
}

function removeNotifier(notifier) {
  document.body.removeChild(notifier);
}

const NotificationManager = {
  autosave: (messageHeader = 'Auto Saved') => {
    const notifier = mountNotification('autosave', messageHeader);
    notifier.classList.add('notification__autosave-wrapper');
  },
  success: (status, messageHeader, messageText) => {
    const notifier = mountNotification(status, messageHeader, messageText);
    notifier.classList.add('notification-success');
  },
  error: (status, messageHeader, messageText) => {
    const notifier = mountNotification(status, messageHeader, messageText);
    notifier.classList.add('notification-error');
  }
};

export default NotificationManager;



// WEBPACK FOOTER //
// ./src/app/dom-managers/notification.js